export default __webpack_public_path__ + "static/media/accueilEcole.9471204a.jpg";